<button (click)="toggle()" mat-icon-button>
  @if (opened()) {
    <mat-icon>menu_open</mat-icon>
  } @else {
    <mat-icon>menu</mat-icon>
  }
</button>
